import {
  MOST_RECENT_ARTICLES_FAIL,
  MOST_RECENT_ARTICLES_SUCCESS,
  MOST_RECENT_ARTICLES_REQUEST,
  GET_NEWS_USER_INFO,
  GET_NEWS_USER_INFO_FAIL,
  POST_NLSUB_REQ,
  POST_NLSUB_SUCCESS,
  POST_NLSUB_FAIL,
  SEND_NEWSLETTER_DATA_REQ,
  SEND_NEWSLETTER_DATA_SUCCESS,
  SEND_NEWSLETTER_DATA_FAIL,
  FIRST_VISIT_COUNTER,
  SEND_EMAIL_REQ,
  SEND_EMAIL_FAIL,
  SEND_EMAIL_SUCCESS,
  FIRST_VISIT_TRUE,
} from "../constants";

export const mostRecentListReducer = (state = { articles: [] }, action) => {
  switch (action.type) {
    case MOST_RECENT_ARTICLES_REQUEST:
      return { loading: true, articles: [] };
    case MOST_RECENT_ARTICLES_SUCCESS:
      return { loading: false, articles: action.payload };
    case MOST_RECENT_ARTICLES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const newsUserInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_NEWS_USER_INFO:
      return { ctaInfo: action.payload };
    case GET_NEWS_USER_INFO_FAIL:
      return { error: action.payload };
    default:
      return state;
  }
};

export const newsletterSubReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_NLSUB_REQ:
      return { loading: true };
    case POST_NLSUB_SUCCESS:
      return { loading: false, success: true };
    case POST_NLSUB_FAIL:
      return { loading: false, error: "Server Error" };
    default:
      return state;
  }
};

export const subscribePageDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_NEWSLETTER_DATA_REQ:
      return { loading: true };
    case SEND_NEWSLETTER_DATA_SUCCESS:
      return { loading: false, success: true };
    case SEND_NEWSLETTER_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const firstVisitReducer = (state = {}, action) => {
  switch (action.type) {
    case FIRST_VISIT_COUNTER:
      return { varSet: true };
    case FIRST_VISIT_TRUE:
      return { status: true };
    default:
      return state;
  }
};

export const newsletterBannerReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_EMAIL_REQ:
      return { loading: true };
    case SEND_EMAIL_SUCCESS:
      return { loading: false, success: true };
    case SEND_EMAIL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
